module.exports = __webpack_public_path__ + "img/safe_dados.5507e4f4.svg";